import { createContext } from 'react';

const LoopApiServiceContext = createContext(null);

export default LoopApiServiceContext;
